import { connect } from 'react-redux'

import {
  setFilterStatus,
  getProductList,
} from 'reduxpath/ducks/Product/List'

import FilterStatus from './units'

const mapStateToProsp = state => ({
  param: {
    searchProfileField: state.ProductList.searchProfileField,
    selectedCountry: state.Reference.selectedCountry,
    selectedService: state.Reference.selectedService,
    sortField: state.ProductList.sortField,
    sortOrder: state.ProductList.sortOrder,
    filterStatus: state.ProductList.filterStatus,
  },
})

const mapDispatchToProps = dispatch => ({
  submitFilters(param) {
    return (e) => {
      e.preventDefault()
      const {
        searchProfileField,
        selectedCountry,
        selectedService,
        sortField,
        sortOrder,
      } = param
      const filterStatus = parseInt(e.target.value, 10)
      dispatch(setFilterStatus(filterStatus))

      const qs = {
        sort: {
          isEligible: 'DESC',
          [sortField]: sortOrder,
        },
        limit: 10,
        skip: 0,
        where: {
          isEligible: false,
          isPublished: true,
        },
      }

      if (searchProfileField.length > 0) {
        const regexEmail = /^([a-z0-9_.-]+)([+0-9]+)*@([\da-z.-]+)\.([a-z.]{2,6})$/

        if (regexEmail.test(searchProfileField)) {
          qs.where.or = [
            { email: { like: `%${searchProfileField}%` } },
          ]
        } else {
          qs.where.or = [
            { name: { like: `%${searchProfileField}%` } },
            { profileId: { like: `%${searchProfileField}%` } },
          ]
        }
      }

      if (selectedService) {
        qs.where.service = selectedService
      }
      if (selectedCountry) {
        qs.where.country = selectedCountry
      }
      if (filterStatus >= 0) {
        qs.where.status = filterStatus
      }

      dispatch(getProductList(qs))
    }
  },
})

export default connect(mapStateToProsp, mapDispatchToProps)(FilterStatus)
